// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"668":"984ca246","760":"f28ca2e2"}[chunkId] + ".chunk.css";
};